import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import qs from 'qs'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadContacts(fetchParams: any) {
  try {
    const url = withPbx('contacts')

    const { data } = await http.get(url, {
      params: fetchParams,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function loadContactsSettings() {
  try {
    const url = withPbx('contacts/settings')

    const { data } = await http.get(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }
    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function createContact(contactData: any) {
  try {
    const url = withPbx('contacts')

    const { data } = await http.post(url, contactData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function updateContact(id: number | string, contactData: any) {
  try {
    const url = withPbx(`contacts/${id}`)

    const { data } = await http.put(url, contactData)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteContacts(deleteParams: any) {
  try {
    const url = withPbx('contacts')

    const { data } = await http.delete(url, {
      params: deleteParams,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function destroyContacts(payload: {
  contactIds?: number[]
  destroyAll?: boolean
  org?: string
  searchParameter?: string
}) {
  try {
    const url = withPbx('contacts/destroy')

    const { data } = await http.post(url, payload)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function dialContact(dialParams: any) {
  try {
    const url = withPbx('contacts/dial')

    const { data } = await http.post(url, dialParams)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function updateContactsSettings(contactsSettings: any) {
  try {
    const url = withPbx('contacts/settings')

    const { data } = await http.post(url, {
      dialables: contactsSettings,
    })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function importContacts(importParams: any) {
  try {
    const url = withPbx('contacts/import')

    const { data } = await http.post(url, importParams)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function exportContacts(payload: {
  format: 'text/csv' | 'text/vcard'
  contactIds?: number[]
  org?: string
  searchParameter?: string
}) {
  try {
    const url = withPbx('contacts/export')

    const { data } = await http.post(url, payload, {
      responseType: 'blob',
    })

    return {
      status: 'success' as const,
      payload: data as Blob,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
